/**
 * 自定义短信营销-基础信息模块
 */
// import { lazy } from 'ice';
import Form from './Form';
import utils from '@/common/utils';

export default {
  data: () => ({
    smsPoNum: '', // PO号
    taskName: '', // 活动名称
    taskStartTime: '', // 活动开始时间
    taskEndTime: '', // 活动结束时间
    // crowdDelayTime: 7200000, // 人群运算时间点，默认凌晨2点
    sendTime: '',// 每次短信投放时间点
    // sendRule: 1 // 投放规则，每多少天发送一次
    sendStrategy: '', // 投放策略，在预测时间前多少天推送，0表示选了在当天推送，其他表示自己填时间
  }),

  validators: {
    smsPoNum: (val) => new Promise((resolve, reject) => {
      try {
        // if (val.smsPoNum === '' && utils.isPGShop()) {
        //   reject(new Error('PO号不能为空'));
        // } else {
          resolve();
        // }
      } catch (error) {
        throw error;
      }
    }),
    taskName: (val) => new Promise((resolve, reject) => {
      try {
        if (!val.taskName) {
          reject(new Error('活动名称不能为空'));
        } else if (val.taskName.length > 32){
          reject(new Error('活动名称过长'));
        // } else if(utils.isTitleUnqualified(val.taskName) !== false){
        //   reject(new Error(`${utils.titleUnqualifiedTip('活动名称')} 消息标题中包含特殊字符“${utils.isTitleUnqualified(val.taskName)[0]}”请修改后重试！`))
        }else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
    taskStartTime: (val) => new Promise((resolve, reject) => {
      try {
        if (!val.taskStartTime) {
          reject(new Error('请选择活动开始时间'));
        } else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
    taskEndTime: (val) => new Promise((resolve, reject) => {
      try {
        if (!val.taskEndTime) {
          reject(new Error('请选择活动结束时间'));
        } else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
    sendStrategy: (val) => new Promise((resolve, reject) => {
      try {
        if (val.sendStrategy !== 0 && !val.sendStrategy) {
          reject(new Error('投放策略不能为空'));
        } else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
    // 人群运算时间点
    // crowdDelayTime: (val) => new Promise((resolve, reject) => {
    //   try {
    //     if (!val.crowdDelayTime) {
    //       reject(new Error('请选择人群运算时间点'));
    //     } else {
    //       resolve();
    //     }
    //   } catch (error) {
    //     throw error;
    //   }
    // }),
    // 每次短信投放时间点
    sendTime: (val) => new Promise((resolve, reject) => {
      try {
        if (val.sendTime.length === 0 && val.sendTime === "") {
          reject(new Error('请选择每次邀请投放时间点'));
        } else if ((Number(val.sendTime) < 32400000 || Number(val.sendTime) > 71940000)){
          reject(new Error('投放时间点需在9:00-19:59之间'));
        } else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
    // 投放规则
    // sendRule: (val, shopType) => new Promise((resolve, reject) => {
    //   try {
    //     if (!val.sendRule) {
    //       reject(new Error('投放规则不能为空'));
    //     } else {
    //       resolve();
    //     }
    //   } catch (error) {
    //     throw error;
    //   }
    // }),
  },
  components: {
    Form: Form,
  }
}
